import { ChangeDetectorRef, Component, ViewChild, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { ThemeModeService } from './core/services/theme-mode.service';
import { MatDialog } from '@angular/material/dialog';
import { MatDrawer } from '@angular/material/sidenav';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppService } from './app.service';
import { AlertService } from './views/shared/alert/alert.service';
import { HeaderService } from './views/shared/header/header.service';

@Component({

  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  title = 'demo1';
  isLogin: boolean = false
  @ViewChild('drawer') drawer?: MatDrawer;
  @ViewChild('callDrawer') callDrawer?: MatDrawer;
  items = [
    { name: 'Dashboard', route: '/dashboard', icon: 'home' },
    { name: 'Calls-care', route: '/calls-care', icon: 'phone' },
    { name: 'Tickets', route: '/tickets', icon: 'person' },
    { name: 'Settings', route: '/settings', icon: 'settings' }
  ];
  returnUrl: any;
  result: any
  constructor(
    public mainService: AppService,
    public cdr: ChangeDetectorRef,
    public router: Router,
    public headerService: HeaderService,
    public alertServices: AlertService,
    public dialog: MatDialog,
    public themeModeService: ThemeModeService
  ) {
    this.returnUrl = '';

    this.mainService.cadStatusData$.subscribe(res => {
      this.isLogin = res;
    })
    this.mainService.sideNavToggle$.subscribe(res => {
      this.result = res
      if (this.result) {
        this.drawer?.open()
        this.callDrawer?.open()
      } else if (!this.result) {
        this.drawer?.close()
        this.callDrawer?.close()
      }
    })
  }
  private routerSubscription!: Subscription;
  ngOnInit() {
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Trigger your method here when the URL changes
        this.onRouteChange(event.url);
      }
    });
  }

  dashboard = 'dashboard'
  superAdminDashboard = 'superAdminDashboard'
  clientDashboard = 'clientDashboard'
  devRole = 'role'
  onRouteChange(url: string) {
    let session = localStorage?.['authToken']
    let userRole = localStorage.getItem('roles')
    if (url == "/login" && session != undefined) {

      this.router.navigate(['smartdocs/folders'])

    }
    else if (url === '/') {
      this.reloadComponent()
    }
  }

  reloadComponent() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {

      this.router.navigate(['smartdocs/folders'])

    });
  }



  ngAfterViewInit() {
    this.cdr.detectChanges();
  }
  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }



}
